export default function WhatsAppButton() {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirvizedanismanlik.net web siteniz üzerinden yazıyorum.');
  const whatsappUrl = `https://wa.me/905422671171?text=${whatsappMessage}`;
  const phoneUrl = 'tel:+905422671171';

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3">
      {/* Phone Call Button */}
      <a
        href={phoneUrl}
        className="w-14 h-14 bg-secondary hover:bg-secondary/90 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer"
        aria-label="Telefon"
      >
        <i className="ri-phone-line text-2xl"></i>
      </a>

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
